function FAQItem({ question, answer, open, onToggle }) {
  return (
    <div className="border-b border-gray-200">
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-between py-5 text-left contatti-faq-question"
        aria-expanded={open}
      >
        <span>{question}</span>

        <span
          className={`base-title transition-transform duration-300 ease-out ${
            open ? "rotate-45" : "rotate-0"
          }`}
        >
          +
        </span>
      </button>

      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <div
            className={`base-paragraph base-text-container transition-all duration-300 ease-out ${
              open
                ? "translate-y-0 opacity-100"
                : "-translate-y-1 opacity-0"
            }`}
          >
            {answer}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQItem;